import { render, staticRenderFns } from "./PropertyMultipleText.vue?vue&type=template&id=098a4afe&"
import script from "./PropertyMultipleText.vue?vue&type=script&lang=js&"
export * from "./PropertyMultipleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports